import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import { useCities } from "@/common/hooks/queries/useCities";
import useDebounce from "@/common/hooks/useDebounce";
import { GeoTransformers } from "@/common/services/geoTransformers";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterCitySheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: cityOptions,
  } = useCities({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: GeoTransformers.optionsTransformer()
    }),
  });

  return (
    <SheetFiltersItem
      label={dashboardFilters[DashboardFilters.City]}
      value={filters[DashboardFilters.City]?.value || ''}
      options={[{ label: 'Todas', value: '' }, ...cityOptions]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.City]: value }))}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterCitySheet;
